import angular from 'angular'

// components
import booleanToggle from './component/booleanToggle.js'

export default angular
  .module('portalApp.booleanToggle', [])
  .component('booleanToggle', booleanToggle)
  .name
